// import { IonContent, IonHeader, IonPage } from "@ionic/react";
// import UserCard from "../components/card/UserCard";
// import Header from "../components/layout/Header";
// import { useState, useEffect } from "react";
// import { getAllProfiles } from "../api/requests/profile";
// import { Helmet } from "react-helmet-async";

// const Friends = () => {
//   const [allUsers, setAllUsers] = useState([]);

//   useEffect(() => {
//     getAllProfiles().then((res) => {
//       if (res.data) {
//         setAllUsers(res.data);
//       }
//     });
//   }, []);

//   return (
//     <>
//       <Helmet>
//         <meta name="robots" content="noindex, nofollow" />
//       </Helmet>
//       <IonPage>
//         <IonHeader mode="ios">
//           <Header />
//         </IonHeader>
//         <IonContent>
//           <div className="display-flex flex-direction-c">
//             {allUsers.map((user) => (
//               <UserCard key={user._id} user={user} />
//             ))}
//           </div>
//         </IonContent>
//       </IonPage>
//     </>
//   );
// };

// export default Friends;
import {
  IonContent,
  IonHeader,
  IonPage,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonSpinner,
} from "@ionic/react";
import UserCard from "../components/card/UserCard";
import Header from "../components/layout/Header";
import { useState, useEffect, useCallback, useRef } from "react";
import { getAllProfiles } from "../api/requests/profile";
import { Helmet } from "react-helmet-async";

const LIMIT = 20;

const Friends = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState("");
  const loadingRef = useRef(false);
  const pageRef = useRef(1);

  const loadProfiles = useCallback(
    async ({ nextPage = 1, reset = false } = {}) => {
      if (loadingRef.current) return;

      try {
        loadingRef.current = true;

        if (nextPage === 1) {
          setInitialLoading(true);
        } else {
          setLoadingMore(true);
        }

        setError("");

        const res = await getAllProfiles({
          page: nextPage,
          limit: LIMIT,
        });

        if (!res?.data) {
          throw new Error("No response from server");
        }

        const newProfiles = res.data.profiles || [];
        const pagination = res.data.pagination || {};

        setAllUsers((prev) => {
          const merged = reset ? newProfiles : [...prev, ...newProfiles];

          // Prevent duplicate users if the same page is requested twice
          return Array.from(
            new Map(merged.map((user) => [user._id, user])).values(),
          );
        });

        pageRef.current = nextPage;
        setPage(nextPage);
        setHasMore(Boolean(pagination.hasMore));

        console.log("Profiles pagination:", {
          nextPage,
          received: newProfiles.length,
          pagination,
        });
      } catch (err) {
        console.error(err);
        setError("Failed to load profiles. Please try again.");
      } finally {
        loadingRef.current = false;
        setInitialLoading(false);
        setLoadingMore(false);
      }
    },
    [],
  );

  useEffect(() => {
    loadProfiles({ nextPage: 1, reset: true });
  }, [loadProfiles]);

  const handleLoadMore = async (event) => {
    const nextPage = page + 1;

    await loadProfiles({
      nextPage,
      reset: false,
    });

    event.target.complete();
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <IonPage>
        <IonHeader mode="ios">
          <Header />
        </IonHeader>

        <IonContent fullscreen>
          <div
            className="friends-page"
            style={{
              padding: "12px",
              maxWidth: "680px",
              margin: "0 auto",
            }}
          >
            {initialLoading && (
              <div
                style={{
                  minHeight: "50vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IonSpinner name="crescent" />
              </div>
            )}

            {!initialLoading && error && (
              <div
                style={{
                  textAlign: "center",
                  padding: "24px",
                  color: "var(--ion-color-danger)",
                }}
              >
                {error}
              </div>
            )}

            {!initialLoading && !error && allUsers.length === 0 && (
              <div
                style={{
                  textAlign: "center",
                  padding: "32px 16px",
                  color: "#777",
                }}
              >
                No Loons found yet.
              </div>
            )}

            {!initialLoading && !error && (
              <div className="display-flex flex-direction-c">
                {allUsers.map((user) => (
                  <UserCard key={user._id} user={user} />
                ))}
              </div>
            )}

            <IonInfiniteScroll
              threshold="120px"
              disabled={!hasMore || initialLoading}
              onIonInfinite={handleLoadMore}
            >
              <IonInfiniteScrollContent
                loadingSpinner="crescent"
                loadingText="Loading more Loons..."
              />
            </IonInfiniteScroll>
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default Friends;
